import { PageHeader, Checkbox, Tooltip } from "antd";
import React, { Component } from "react";
import AgregarTipoDeFlujo from "./AgregarTipoDeFlujo/AgregarTipoDeFlujo";
import { TableItem, ButtonItem } from "../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import { EditOutlined } from "@ant-design/icons";
import EditarTipoDeFlujo from "./EditarTipoDeFlujo/EditarTipoDeFlujo";

class TiposDeFlujos extends Component {
  state = {
    modalAgregarTipoDeFlujo: false,
    todasTiposDeFlujos: [],
    modalEditarTipoDeFlujos: false,
    modalEditarTipoDeFlujosId: null,
    loading: false
  };
  componentDidMount() {
    this.consultarTiposDeFlujos();
  }

  abrirEditarTiposDeFlujos(id) {
    console.log(id);
    this.setState({ modalEditarTipoDeFlujos: true, modalEditarTipoDeFlujosId: id });
  }
  

  cerrarEditarTiposDeFlujos() {
    this.setState({ modalEditarTipoDeFlujos: false, modalEditarTipoDeFlujosId: null });
    this.consultarTiposDeFlujos();
  }

  consultarTiposDeFlujos() {
    this.setState({loading: true})
    axios
      .post(
        "tiposdeflujos/selectTodosTiposDeFlujos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({loading: false})
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasTiposDeFlujos: res.data.map((value) => {
              return {
                ...value,
                accion: { _id: value._id, estado: value.estado },
              };
            }),
          });
        }
      });
  }
  abrirAgregarTipoDeFlujo() {
    this.setState({ modalAgregarTipoDeFlujo: true });
  }
  cerrarAgregarTipoDeFlujo() {
    this.setState({ modalAgregarTipoDeFlujo: false });
    this.consultarTiposDeFlujos();
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
      },
      {
        title: "Ingreso",
        dataIndex: "ingreso",
        key: "ingreso",
        render: (value) => <Checkbox checked={value} />,
        align: "center",
      },
      {
        title: "Considerar en Flujo",
        dataIndex: "considerarEnFlujo",
        key: "considerarEnFlujo",
        render: (value) => <Checkbox checked={value} />,
        align: "center",
      },
      {
        title: "Generar DIOT",
        dataIndex: "generarDIOT",
        key: "generarDIOT",
        render: (value) => <Checkbox checked={value} />,
        align: "center",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value) => {
          let buttons = [];

          buttons.push(
            <Tooltip key="editar" title="Editar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.abrirEditarTiposDeFlujos(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Tipos De Flujos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={this.props.permisoAgregarTipoDeFlujo &&
            <ButtonItem
              type="primary"
              key="agregarTipoDeFlujo"
               olivo
              onClick={this.abrirAgregarTipoDeFlujo.bind(this)}
               className="botonAgregar"
            >
              Agregar Tipo De Flujo
            </ButtonItem>
          }
        />
        <TableItem
        loading={this.state.loading}
          size="small"
          dataSource={this.state.todasTiposDeFlujos}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => this.abrirEditarTiposDeFlujos(record._id),
          })}
        />
        {this.props.permisoAgregarTipoDeFlujo &&
          <AgregarTipoDeFlujo
            visible={this.state.modalAgregarTipoDeFlujo}
            cerrarAgregarTipoDeFlujo={this.cerrarAgregarTipoDeFlujo.bind(this)}
          />
        }
        {this.props.permisoEditarTipoDeFlujo &&
          <EditarTipoDeFlujo
              visible={this.state.modalEditarTipoDeFlujos}
              cerrarEditarTiposDeFlujos={this.cerrarEditarTiposDeFlujos.bind(this)}
              idTipoDeFlujo={this.state.modalEditarTipoDeFlujosId} 
          />
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarTipoDeFlujo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cdd32f30e81b54183cfa3")?.activado,
    permisoEditarTipoDeFlujo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cdd61f30e81b54183cfa4")?.activado,
    permisoDeshabilitarTipoDeFlujo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce7d2f30e81b54183cfb7")?.activado,
  };
};

export default connect(mapStateToProps)(TiposDeFlujos);
